<template>
  <star-rating-accessible v-model="rating" :name="name" :star-size="30">
    <template #errorMessage="{ errorMessage }">
      <slot name="errorMessage" :error-message="errorMessage" />
    </template>
    <template #pointer>
      <slot name="pointer" />
    </template>
    <template #helpText>
      <slot name="helpText" />
    </template>
  </star-rating-accessible>
</template>

<script lang="ts">
import {
  Component,
  Model,
  Prop,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'

@Component({})
class ReviewStarRating extends Vue {
  @Prop({ required: true })
  name: string

  @Model()
  rating: number
}

export default toNative(ReviewStarRating)
</script>

<style scoped>
.vue-star-rating-rating-text.denominator {
  margin: 0 1em 0 0.3em !important;
}

.vue-star-rating-rating-text {
  margin: 0 0 0 1em !important;
  align-self: center;
  display: block;
}
</style>
